// For full API documentation, including code examples, visit http://wix.to/94BuAAs

$w.onReady(function () {
	//TODO: write your page related code here...

});

export function anchor1_onviewportLeave() {
    $w("#columnStrip10").show();
    $w("#horizontalMenu3").show();
    $w("#image36").hide();
    $w("#image38").hide();
    $w("#image37").hide();
    $w("#columnStrip3").hide();
}

export function anchor1_oviewportEnter(){
    $w("#columnStrip10").hide();
    $w("#horizontalMenu3").hide();
    $w("#image36").show();
    $w("#image38").show();
    $w("#image37").show();
    $w("#columnStrip3").show();
}